import { Component, OnInit, Input, PLATFORM_ID, Inject } from '@angular/core';
import { ComponentRendering } from '@sitecore-jss/sitecore-jss-angular';
import { Subscription } from 'rxjs';
import { JssContextService } from '../../jss-context.service';
import { JssStylingService } from '../../jss-styling.service';
import { isPlatformServer } from '@angular/common';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-kiosk-insurance-clerks',
  templateUrl: './kiosk-insurance-clerks.component.html',
  styleUrls: ['./kiosk-insurance-clerks.component.scss']
})
export class KioskInsuranceClerksComponent implements OnInit {
  @Input() rendering: ComponentRendering;
  _isPlatformServer: boolean = false;
  dynamicClass: string;
  dynamicId: string;
  language:string;
  params: any;
  clerks:any;
  public contextSubscription: Subscription;
  
  constructor(@Inject(PLATFORM_ID) public readonly platformId: string, public jssStylingService: JssStylingService, public jssContext: JssContextService, public activatedRoute: ActivatedRoute) { }

  ngOnInit() {
    this._isPlatformServer = isPlatformServer(this.platformId);
    this.dynamicClass = this.jssStylingService.getComponentClass(this.rendering);
    this.dynamicId = this.jssStylingService.getComponentId(this.rendering);
    this.contextSubscription = this.jssContext.state.subscribe((newState) => {
      this.language = newState.language
    });
    this.activatedRoute.queryParams.subscribe((params: any) => {
      this.params = params;
    });

    if(this.params["branchCode"]){
      var branchMatchingParams = (this.rendering?.fields?.result as [])?.filter((x:any) => x.BranchCode==this.params["branchCode"])[0];
      if(branchMatchingParams){
        this.clerks = (branchMatchingParams as any)?.Clerks;
      }
    }
    // remove this after implementation is done
    // console.log('KioskInsuranceClerks component initialized with component data', this.rendering);
    // console.log('Clerks', this.clerks);
  }
}
